module.exports = __webpack_public_path__ + "static/extension-manager-e793a99b9171261bd27a69b2db6e3ab8.png";